import React from 'react';
import { useParams } from 'react-router-dom';
import { LegacyAppRedirect } from './LegacyAppRedirect';

/** Legacy /properties/:id/edit → /app/properties/:id/edit */
export function LegacyPropertyEditRedirect() {
  const { id } = useParams();
  return <LegacyAppRedirect ownerTo={`/app/properties/${id}/edit`} />;
}
